import React from "react";
import { Table } from "antd";
import styles from "./table.module.less";

const TableLayout = props => {
    const { highlightRowIndex, rateLimitedIndices, onRowClick, dataSource, columns } = props;
    return (
        <div style={{ overflowX: 'auto' }} className={styles.table}>
            <Table
                rowClassName={(record, index) => {
                    if (highlightRowIndex === index) {
                        return "recommended_Highlight";
                    }
                    if (rateLimitedIndices.includes(index)){
                        return "hideRateLimited";
                    }
                    return "";
                }}
                onRow={(record, index) => {
                    return {
                        onClick: event => onRowClick(index),
                    };
                }}
                dataSource={dataSource}
                columns={columns}
                pagination={false}
                size="middle"
            />
        </div>
    );
};

export default TableLayout;
